import { LocalStorageInstance } from './services/localStroage/LocalStorageService';

export function getUserInfo() {
  return LocalStorageInstance.getUser();
}

export function getCohortId() {
  return (localStorage.getItem('cohortId') || (localStorage.getItem('COHORT_ID') as string)) ?? '';
}

/** Product - STUDIO_X App */
export async function asyncGetUserInfo(): Promise<any> {
  try {
    return new Promise((resolve, reject) => {
      const intervalId = setInterval(() => {
        const userData = localStorage.getItem('user');
        if (userData) {
          clearInterval(intervalId);
          resolve(JSON.parse(userData));
        }
      }, 100);
    });
  } catch (err) {
    console.warn(err);
  }
}
export function getQueryParams(): Record<string, string> {
  const params = new URLSearchParams(window.location.search);
  const result: Record<string, string> = {};
  for (const [key, value] of params.entries()) {
    result[key] = value;
  }
  return result;
}
